// @ts-strict
import {type SupportCaseInput as GeneratedSupportCaseInput} from '@/graphql/types';

export enum StepEnum {
  ContactAndCategory = 'contact_and_category',
  CategoryAndMessage = 'category_and_message',
}

export type SupportMessageSurface = 'contact_us_modal' | 'contact_us_page' | 'standalone_route';

export const SUPPORT_MESSAGE_SOURCES = ['native_ios', 'native_android'] as const;
export type SupportMessageSource = (typeof SUPPORT_MESSAGE_SOURCES)[number];

export type CategoryLevel1 = 'Order' | 'Account' | 'General/Other';

export type WebToCaseFormValues = {
  contactName: string;
  email: string;
  categoryLevel1: CategoryLevel1 | '';
  categoryLevel2ByCategory1: Partial<Record<CategoryLevel1, string>>;
  orderNumbers: string;
  description: string;
};

export const FIELD_IDS = [
  'contactName',
  'email',
  'categoryLevel1',
  'categoryLevel2',
  'orderNumbers',
  'description',
] as const;
export type FieldId = (typeof FIELD_IDS)[number];

export type SupportCaseInput = Omit<GeneratedSupportCaseInput, 'source'> & {
  source?: SupportMessageSurface | SupportMessageSource;
};

export type SubmitResult = {
  success: boolean;
  fieldErrors?: Partial<Record<FieldId, string>>;
  reason?: string;
};

export type FieldContext = {
  fullName: string;
  email: string;
};

export type WebToCaseFieldConfig = {
  id: FieldId;
  step: 1 | 2;
  required?: boolean;
  format?: {pattern: RegExp; errorKey: string};
  defaultValue?: (ctx: FieldContext) => string;
  visibleWhen?: (values: WebToCaseFormValues) => boolean;
};
